export const GENERIC_MODAL_DIALOG_INPUT_PARAMETERS = {
    modalDialogExportTitleIconCss: `fas fa-file-export e-info`,
    modalDialogExportTitle: `Export Data as XLSX File`,
    modalDialogExportTitleDescription: `Data will be exported and the file will include all headers and row descriptions.`,
    modalDialogExportNotificationIconCss: `fas fa-exclamation-triangle e-warning`,
    modalDialogExportNotificationIconWithText: `ATTENTION: `,
    modalDialogExportNotificationIconMessageHeading: `You are exporting data that contain active column filters.`,
    modalDialogExportCancelButtonText: `CANCEL`,
    modalDialogExportSubmitButtonText: `EXPORT`
};

export const GENERIC_MODAL_DIALOG_NOTIFICATION_MESSAGES = {
    modalDialogExportToExcelInvalidRows: `One or more invalid rows are included in the export.`,
    modalDialogExportToExcelFilteredRows: `One or more filters are applied to the data. Only filtered rows will be included.`,
    modalDialogExportToExcelFilteredandInvalidRows: `One or more invalid rows are included in the export along with One or more filters are applied on the data`,
};